import { render, staticRenderFns } from "./SuccessPedestrianAccess.vue?vue&type=template&id=2b0b06e2"
import script from "./SuccessPedestrianAccess.vue?vue&type=script&lang=js"
export * from "./SuccessPedestrianAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports